<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-8">
        <form @submit.prevent="saveVideo()" autocomplete="off">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Informações do Vídeo</h4>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="url">URL do Vídeo (YouTube ou Vimeo)</label>
                    <input
                      id="url"
                      v-model="video.url"
                      name="url"
                      type="text"
                      class="form-control"
                      placeholder="Ex: https://www.youtube.com/watch?v=... ou https://vimeo.com/..."
                      :class="{ 'is-invalid': submitted && $v.video.url.$error }"
                    />
                    <small class="text-muted">Aceitamos URLs de YouTube (watch, youtu.be, embed, shorts) e Vimeo. O título e a thumbnail serão preenchidos automaticamente.</small>
                    <div v-if="submitted && !$v.video.url.required" class="invalid-feedback">URL é obrigatória.</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="title">Título (opcional — sobrescreve o título do provedor)</label>
                    <input
                      id="title"
                      v-model="video.title"
                      name="title"
                      type="text"
                      class="form-control"
                      placeholder="Deixe em branco para usar o título do YouTube/Vimeo"
                    />
                  </div>
                </div>
              </div>

              <div v-if="video.thumbnail_url" class="row">
                <div class="col-sm-12">
                  <label class="d-block">Pré-visualização</label>
                  <img :src="video.thumbnail_url" alt="Thumbnail" class="rounded" :style="{ maxWidth: '320px', maxHeight: '180px', objectFit: 'cover' }" />
                  <p class="text-muted mt-2 mb-0 small">
                    Provedor: <strong>{{ providerLabel[video.provider] || video.provider }}</strong>
                    <span v-if="video.external_id"> · ID: <code>{{ video.external_id }}</code></span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="float-right">
                <button type="button" @click="cancelar()" class="btn btn-dark mr-4">Cancelar</button>
                <button type="submit" class="btn btn-primary mr-1">Salvar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: { Layout, PageHeader },
  name: 'Video',
  page: {
    title: 'Vídeo',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  data () {
    return {
      video: {
        id: '',
        title: '',
        url: '',
        provider: '',
        external_id: '',
        thumbnail_url: ''
      },
      loading: true,
      providerLabel: { youtube: 'YouTube', vimeo: 'Vimeo' },
      submitted: false,
      title: 'Vídeo',
      items: [
        { text: 'Vídeos', href: '/settings/site/videos' },
        { text: 'Novo Vídeo', active: true }
      ]
    }
  },
  validations: {
    video: {
      url: { required }
    }
  },
  mounted () {
    this.loadItem()
  },
  computed: {
    ...mapState('videos', { data: 'video' })
  },
  methods: {
    ...mapActions('videos', {
      fetch: 'GetVideo',
      postData: 'SaveVideo'
    }),
    cancelar () {
      this.$router.push({ name: 'site-videos' })
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        this.items[1].text = 'Editar Vídeo'
        this.fetch(this.$route.params.id)
          .then(() => {
            this.video = { ...this.data }
          }).then(() => {
            loader.hide()
          })
      }
    },
    async saveVideo () {
      this.submitted = true
      window.scroll(0, 0)
      this.$v.video.$touch()
      if (this.$v.video.$invalid) {
        return
      }
      let loader = this.$loading.show()
      const payload = {
        id: this.video.id || undefined,
        url: this.video.url,
        title: this.video.title || ''
      }
      this.postData(payload).then(() => {
        loader.hide()
        successMessage('Sucesso: Dados atualizados com sucesso.', 2500)
        this.cancelar()
      }).catch((err) => {
        loader.hide()
        const msg = err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : err.message
        errorMessage('Alerta: ' + msg)
      })
    }
  }
}
</script>
